import { h } from "vue";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

export enum CheckoutPageRoutes {
    ShoppingCart = "shoppingCart",
    Checkout = "checkout",
}

const EmptyRouteComponent = {
    render: () => h("div"),
};

const routes: Array<RouteRecordRaw> = [
    {
        name: CheckoutPageRoutes.ShoppingCart,
        path: "/",
        component: EmptyRouteComponent,
    },
    {
        name: CheckoutPageRoutes.Checkout,
        path: "/utsjekk",
        component: EmptyRouteComponent,
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/",
    },
];

export default function (base?: string) {
    if (!base) return;

    return createRouter({
        history: createWebHistory(base),
        routes,
    });
}
